import { EXTERNAL_LINKS } from '@common/configs';
import { useIsMobile } from '@common/hooks';

import style from './styles.module.scss';

const ExternalLinks = () => {
  const isMobile = useIsMobile();

  return (
    <ul className={!isMobile ? style.list : style['mobile-list']}>
      {Object.entries(EXTERNAL_LINKS).map(([label, href]) => {
        return (
          <li key={label}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {label}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default ExternalLinks;
